import { View, Text, Checkbox } from "@src/components";
import { memo, useCallback, useMemo } from "react";
import { StyleSheet } from "react-native-unistyles";
import type { UserWithSites } from "@src/features/settings/data/mock-all-users";
import { Pressable } from "react-native";

type SelectableUserListItemProps = {
  user: UserWithSites;
  index: number;
  usersLength: number;
  selected: boolean;
  onToggle: (userId: string) => void;
};

export const SelectableUserListItem = memo(
  ({ user, index, usersLength, selected, onToggle }: SelectableUserListItemProps) => {
    const isLast = useMemo(() => index === usersLength - 1, [index, usersLength]);
    const isLastItemStyle = useMemo(() => ({ borderBottomWidth: isLast ? 0 : 1 }), [isLast]);

    const handleToggle = useCallback(() => {
      onToggle(user.id);
    }, [onToggle, user.id]);

    return (
      <Pressable onPress={handleToggle}>
        <View
          bg="surfaceCard"
          flexDirection="row"
          justifyContent="space-between"
          style={[styles.item, isLastItemStyle]}
        >
          <View gap="xs" style={styles.userInfo}>
            <Text textStyle="sm/regular">{user.name || user.email}</Text>
            {user.siteNames.length > 0 && (
              <Text textStyle="xs/regular" color="textMuted">
                {user.siteNames.join(", ")}
              </Text>
            )}
            {user.email && user.name && (
              <Text textStyle="xxs/regular" color="textMuted">
                {user.email}
              </Text>
            )}
            {user.phoneNumber && (
              <Text textStyle="xxs/regular" color="textMuted">
                {user.phoneNumber}
              </Text>
            )}
          </View>
          <Checkbox checked={selected} onToggle={handleToggle} />
        </View>
      </Pressable>
    );
  },
);

const styles = StyleSheet.create((theme) => ({
  item: {
    paddingVertical: theme.spacing.md,
    borderBottomColor: theme.colors.borderCard,
    gap: theme.spacing.xxs,
    paddingHorizontal: theme.spacing.xl,
  },
  userInfo: {
    flex: 1,
  },
}));
